import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  enumData: any;
}

export default function EnumSelect({ enumData, ...props }: Props) {
  return (
    <Select maxTagCount="responsive" allowClear {...props}>
      {Object.keys(enumData)
        .filter(x => !x.startsWith('__'))
        .map((k, i) => {
          return (
            <Select.Option key={i} value={enumData[k]}>
              {enumData.__customLabel ? enumData.__customLabel[k] : k}
            </Select.Option>
          );
        })}
    </Select>
  );
}
